export enum Status {
    NAO_PAGO = "Não pago",
    PAGO = "Pago"
}